var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.615 10.667a.615.615 0 1 0 0 1.23h14.77a.615.615 0 0 0 0-1.23zm0 4.922a.615.615 0 1 0 0 1.231h14.77a.615.615 0 0 0 0-1.23zm0 4.923a.615.615 0 1 0 0 1.231h14.77a.615.615 0 1 0 0-1.23z"
  })));
};
export default SvgMenu;